<script setup lang="ts">
import type { CreateCompanyForEmployerInvoiceDto } from '@swipe4work/models-orval'
import nProgress from 'nprogress'
import BillingForm from './components/BillingForm.vue'

definePage({
  path: 'facturatie',
  name: '/onboarding/billing',
  meta: {
    layout: 'false',
    allowedRoles: [ 'CustomerOnboarding' ],
  },
})

const { t } = useI18n()
const toast = useToast()

const onboardingStore = useOnboardingStore()
const { selectedPaymentMethod, invoiceModel } = storeToRefs(onboardingStore)

function prevPage() {
  onboardingStore.goToPage(3)
}

if (!selectedPaymentMethod.value) {
  onboardingStore.goToPage(3)
}

const submitting = ref(false)

async function submit(model: CreateCompanyForEmployerInvoiceDto, hasAcceptedTermsAndConditions: boolean) {
  nProgress.start()
  submitting.value = true
  invoiceModel.value = model
  const success = await onboardingStore.createCompany(hasAcceptedTermsAndConditions)
  if (success) {
    await onboardingStore.finishOnboarding()
  } else {
    toast.error(t('onboarding.submitting.error'))
  }
  nProgress.done()
  submitting.value = false
}
</script>

<template>
  <template v-if="submitting">
    <Card>
      <template #title>
        <h2>{{ t("onboarding.submitting.title") }}</h2>
      </template>
      <template #content>
        {{ t("onboarding.submitting.body") }}
      </template>
    </Card>
  </template>

  <BillingForm v-else @next-page="submit" @prev-page="prevPage" />
</template>
